import ajax from '../../lib/ajax';
import {Store,Module,ActionContext} from 'vuex'
interface projectState{
    flowTypeNotStep:any,
    projectName:any,
}
class projectStore implements Module<projectState,any>{
    namespaced=true;
    state = {
        flowTypeNotStep: [],
        projectName:''
    }
    mutations:any = {
        setProjectId(state:any, id:any) {
            state.projectId = id;
        }
    }
    actions = {
        //获取流程分类
        async GetFlowTypeNotStep(content:ActionContext<projectState,any>) {
            content.state.flowTypeNotStep = (await ajax.get('/api/services/app/Workflow/GetFlowTypeNotStepAsync')).data.result.map((item:any) => {
                return { label: item.displayName, value: item.id, name: item.flowName}
            })
        }
    }
}
const workflow = new projectStore();
export default workflow;